import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { mapProps, compose } from 'recompose'
import { IconButton } from 'react-toolbox/lib/button'
import { Link } from 'react-router-dom'
import { Flex } from 'reflexbox'
import T from 'i18n-react'
import notifyHoc from 'containers/App/Notification/Notify'
import withAllRoles from 'containers/Role/Hide/AllGlobalRoles'
import { GLOBAL_ROLES } from 'containers/Role/constants'

import styles from './styles.scss'

const InfoButton = notifyHoc(IconButton)

const MailboxNotification = (props) => {
  return (
    <Flex styleName='inboxWrapper'>
      <Flex styleName='circle'>
        <span styleName='circleText'>
          {props.count}
        </span>
      </Flex>
      <Link to='/project/approvals'>
        <InfoButton
          message={T.translate('pages.app.appbar.notification.approval_inbox')}
          styleName='inboxIcon'
          theme={styles}
          icon='inbox'
        />
      </Link>
    </Flex>
  )
}

MailboxNotification.propTypes = {
  count: PropTypes.number.isRequired,
}

MailboxNotification.defaultProps = {
  count: 0,
}

const withStyle = CSSModules(styles)
const enhance = compose(
  mapProps(
    (props) => ({
      ...props,
      roles: [
        GLOBAL_ROLES.CLIENT_ACCESS,
      ]
    })
  ),
  withAllRoles,
  withStyle
)

export default enhance(MailboxNotification)
